import getIntl from 'Helpers/intl'
import { atom } from 'jotai'
import { type ReactNode } from 'react'

export interface PageState {
  status: 'initial' | 'error' | 'ready' | 'fetching'
  loading: boolean //  page loader
  errorMessage: ReactNode
}

export const defaultPageState: PageState = {
  status: 'initial',
  loading: false,
  errorMessage: undefined,
}

export const pageState = atom<PageState>(defaultPageState)

export const loaderUpdater =
  (loading: boolean) =>
  (prev: PageState): PageState => ({ ...prev, loading })

export const statusUpdater =
  (status: PageState['status']) =>
  (prev: PageState): PageState => ({ ...prev, status })

export const errorUpdater = (prev: PageState): PageState => {
  return {
    ...prev,
    status: 'error',
    errorMessage: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
  }
}
